import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/EditModal.scss";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import InsertData from "./InsertFiscalCashRegister";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
  updateAlert,
} from "../../Components/Alerts";
import authHeader from "../../Auth/authHeader";
import { ApiLink } from "../../APILink/ApiLink";
import { FaCashRegister } from "react-icons/fa6";
import "jspdf-autotable";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";
import DataGridWithActions from "../../Components/DataGridWithActions";
import {
  ElementsParagraph,
  TitleElements,
} from "../../Components/HeadersCRUD-s";
import fiscalCashregisterHeader from "./FiscalCashRegisterGrid";
import { formatDate } from "../../Components/formatDate";
import Autocomplete from "@mui/material/Autocomplete";
import { getCompanyUnits } from "../../GetData/CompanyUnitsData";
export default function FiscalCashRegister() {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    Id: "",
    CashRegisterHash: "",
    POSID: "",
    CompanyID: "",
    LocationName: "",
    Description: "",
    IsActive: false,
    UnitID: 0,
  });
  const [company, setCompany] = useState([]);
  const [paymentsAccounts, setPaymentsAccounts] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "FiscalCashRegister", {
        headers,
      });
      setData(response.data);
      console.log(response.data);
      
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const headers = authHeader();
  const email = LoginUserDetailed(); // replace with your implementation of LoginUserDetailed()

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "FiscalCashRegister" + `/${deleteItemId}`,
        { headers },
      );

      const result = response.data;

      if (result.success) {
        handleSuccess("Regjistri u fshi me sukses."); // Mesazhi i suksesit
        fetchData(); // Rimbush të dhënat pas fshirjes
      } else {
        deleteAlert(result.message || "Fshirja nuk u krye."); // Mesazhi nga backend në rast dështimi
      }
    } catch (error) {
      deleteAlert("Ndodhi një gabim gjatë fshirjes."); // Mesazh për gabime të tjera
    }
  };

  //   //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz
  //   const handleEdit = (item) => {
  //     fetchPaymentsAccount(item.CompanyID);
  //     const units = getCompanyUnits(item.CompanyID);
  //     setCompanyUnits(units);

  //     setFormData({
  //       Id: item.Id,
  //       CashRegisterHash: item.CashRegisterHash,
  //       POSID: item.POSID,
  //       CompanyID: item.CompanyID,
  //       LocationName: item.LocationName,
  //       Description: item.Description,
  //       IsActive: item.IsActive,
  //       ModifiedByUser: email,
  //       UnitID: item.UnitID,
  //     });
  //     setShowEditModal(true);
  //   };

  // Shto 'async' këtu
  const handleEdit = async (item) => {
    try {
      fetchPaymentsAccount(item.CompanyID);

      const units = await getCompanyUnits(item.CompanyID);
      setCompanyUnits(units);

      console.log(item);
      
      setFormData({
        Id: item.Id,
        CashRegisterHash: item.CashRegisterHash,
        POSID: item.POSID,
        CompanyID: item.CompanyID,
        LocationName: item.LocationName,
        Description: item.Description,
        IsActive: item.IsActive,
        ModifiedByUser: email,
        UnitID: item.UnitID,
      });

      setShowEditModal(true);
    } catch (error) {
      console.error("Gabim gjatë procesimit të editimit:", error);
    }
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  //Dergimi i kerkeses per editimin e te dhenave ne backend
  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .put(ApiLink.API_URL + "FiscalCashRegister", formData, { headers })
      .then((response) => {
        setShowEditModal(false); // Close the edit modal
        fetchData();
        handleSuccess("P.O.S-i u editua me sukses");
      })
      .catch((error) => {
        // console.log(error);
        errorAlert("P.O.S-i nuk u editua");
      });
  };

  const rows = data.map((item, index) => ({
    id: ++index,
    companyName: item.CompanyName,
    idnumber: item.IdentificationNumber,
    posName: item.AccountName,
    location: item.LocationName,
    description: item.Description,
    isActive: item.IsActive,
    registrationDate: formatDate(item.RegistrationDate),
    fiscalYear: item.FiscalYear,
    deleteItemId: item.Id,
    rowInfo: item,
  }));

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "companies", { headers })
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchPaymentsAccount = async (id) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedgerandCompany",
        { headers, params: { ledger: 101, id: id } },
      );
      setPaymentsAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //   const handleAutocompleteChangeCompany = (event, value) => {
  //     if (value) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         CompanyID: value.CompanyID,
  //       }));
  //       fetchPaymentsAccount(value.CompanyID);

  //             const units = await getCompanyUnits(item.CompanyID);
  //       setCompanyUnits(units);
  //     } else {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         CompanyID: "",
  //       }));
  //     }
  //   };

  // Shto 'async' këtu para (event, value)
  const handleAutocompleteChangeCompany = async (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        CompanyID: value.CompanyID,
      }));

      fetchPaymentsAccount(value.CompanyID);

      try {
        // Përdor 'value.CompanyID' (jo item) dhe 'await'
        const units = await getCompanyUnits(value.CompanyID);
        setCompanyUnits(units);
      } catch (error) {
        console.error("Gabim gjatë marrjes së njësive:", error);
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        CompanyID: "",
      }));
      setCompanyUnits([]); // Sugjerim: zbraz listën nëse fshihet kompania
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) => option.CompanyName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.CompanyName}</span>
        </li>
      </>
    ),
  };

  const handleAutocompletePaymentOptions = (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        POSID: value.AccountID,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        POSID: "",
      }));
    }
  };

  const defaultPropsPaymentOptions = {
    options: paymentsAccounts,
    getOptionLabel: (option) => option.AccountName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.AccountName}</span>
        </li>
      </>
    ),
  };

  const handleAutocompleteCompanyUnit = (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        UnitID: value.UnitID,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        UnitID: "",
      }));
    }
  };

  const defaultPropsCompanyUnit = {
    options: companyUnits,
    getOptionLabel: (option) => option.UnitName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.UnitName}</span>
        </li>
      </>
    ),
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="Crud__Container">
      {/* Shfaqja  e modalit per editimin e te dhenave  */}
      {showEditModal && (
        <div class="edit-modal-wrapper">
          <div className="edit-modal">
            <form
              onSubmit={handleSubmit}
              className="EditModal__Container__Form"
            >
              <div className="EditModal__Container__Form__Container2">
                <div className="EditModal__Container__Form__Container2__firstInput">
                  <TextField
                    style={{ width: "100%" }}
                    required
                    id="CashRegisterHash"
                    label="Hash Code"
                    variant="outlined"
                    type="text"
                    name="CashRegisterHash"
                    value={formData.CashRegisterHash}
                    onChange={(event) => {
                      handleInputChange(event);
                    }}
                  />
                </div>
                <br></br>
                <div className="EditModal__Container__Form__Container2__selects">
                  <div className="EditModal__Container__Form__Container2__selects__textfield_button">
                    <div className="EditModal__Container__Form__Container2__selects__textfield_button__txt">
                      <Autocomplete
                        fullWidth
                        // sx={{ m: 2 }}
                        {...defaultPropsCompany}
                        id="CompanyID"
                        name="CompanyID"
                        includeInputInList
                        onChange={handleAutocompleteChangeCompany}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Kompania"
                            // variant="filled"
                            className="AddPurchaseTotal__Container__Format__SameInput"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            maxHeight: "200px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                            overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                          },
                        }}
                        value={
                          company.find(
                            (option) => option.CompanyID === formData.CompanyID,
                          ) || null
                        }
                      />
                    </div>
                  </div>

                  <div className="EditModal__Container__Form__Container2__selects__textfield_button">
                    <div className="EditModal__Container__Form__Container2__selects__textfield_button__txt">
                      <Autocomplete
                        fullWidth
                        // sx={{ m: 2 }}
                        {...defaultPropsPaymentOptions}
                        id="POSID"
                        name="POSID"
                        includeInputInList
                        onChange={handleAutocompletePaymentOptions}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Arka"
                            // variant="filled"
                            className="AddPurchaseTotal__Container__Format__SameInput"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            maxHeight: "200px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                            overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                          },
                        }}
                        value={
                          paymentsAccounts.find(
                            (option) => option.AccountID === formData.POSID,
                          ) || null
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="EditModal__Container__Form__Container2__selects__textfield_button__txt">
                  <Autocomplete
                    fullWidth
                    // sx={{ m: 2 }}
                    {...defaultPropsCompanyUnit}
                    id="UnitID"
                    name="UnitID"
                    includeInputInList
                    onChange={handleAutocompleteCompanyUnit}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Njesia Organizative"
                        // variant="filled"
                        className="AddPurchaseTotal__Container__Format__SameInput"
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: "200px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                        overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                      },
                    }}
                    value={
                      companyUnits.find(
                        (option) => option.UnitID === formData.UnitID,
                      ) || null
                    }
                  />
                </div>
                <br></br>
                <div className="EditModal__Container__Form__Container2__firstInput">
                  <TextField
                    style={{ width: "100%" }}
                    required
                    id="LocationName"
                    label="Lokacioni"
                    variant="outlined"
                    type="text"
                    name="LocationName"
                    value={formData.LocationName}
                    onChange={(event) => {
                      handleInputChange(event);
                    }}
                  />
                </div>
                <br></br>
                <div className="EditModal__Container__Form__Container2__field__description">
                  <TextareaAutosize
                    style={{ height: "100px" }}
                    className="EditModal__Container__Form__Container2__field__descriptionArea"
                    id="Description"
                    label="Përshkrimi"
                    variant="outlined"
                    placeholder="Description"
                    type="text"
                    name="Description"
                    value={formData.Description}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="EditModal__Container__Form__Container2__buttons">
                  <label className="EditModal__Container__Form__Container2__checkbox-label">
                    <input
                      className="EditModal__Container__Form__Container2__checkbox-input"
                      type="checkbox"
                      id="IsActive"
                      name="IsActive"
                      checked={formData.IsActive}
                      onChange={(event) =>
                        setFormData({
                          ...formData,
                          IsActive: event.target.checked,
                        })
                      }
                    />
                    <span className="EditModal__Container__Form__Container2__checkbox-custom"></span>
                    Artikull Aktiv
                  </label>
                  <div className="EditModal__Container__Form__Container2__save-button">
                    <button
                      type="submit"
                      className="btn btn-success float-end"
                      style={{ width: "120px" }}
                    >
                      Ruaj
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowEditModal(false)}
                    >
                      Anulo
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Tabela per shfaqjen e te dhenave  */}
      <div className="header_flex">
        <TitleElements icon={FaCashRegister} title="Menaxhimi i P.O.S" />
        <div>
          <InsertData fetchData={fetchData} type={"text"} />
        </div>
      </div>
      <ElementsParagraph text="Forma e P.O.S: Menaxhoni, shtoni, editoni dhe fshini P.O.S." />

      <DataGridWithActions
        columns={fiscalCashregisterHeader}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        showPayment={false}
        height={500}
      />
    </div>
  );
}
